var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1379_20655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6812 8.18125C15.6812 7.6125 15.6312 7.06875 15.5344 6.54375H8V9.64062H12.3062C12.1156 10.6375 11.55 11.4812 10.7 12.0469V14.0625H13.2969C14.8062 12.6687 15.6812 10.6187 15.6812 8.18125Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C10.1594 16 11.9719 15.2875 13.2937 14.0656L10.6969 12.05C9.98438 12.5312 9.075 12.8219 8 12.8219C5.91875 12.8219 4.15312 11.4187 3.51875 9.52812H0.859375V11.5937C2.175 14.2031 4.87187 16 8 16Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51875 9.51875C3.35938 9.0375 3.26562 8.52813 3.26562 8C3.26562 7.47188 3.35938 6.95938 3.51875 6.48125V4.41563H0.859375C0.3125 5.49063 0 6.70625 0 8C0 9.29375 0.3125 10.5094 0.859375 11.5844L2.93125 9.96875C2.93125 9.97188 3.51875 9.51875 3.51875 9.51875Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.18438C9.17813 3.18438 10.225 3.59063 11.0625 4.37813L13.3531 2.0875C11.9625 0.79375 10.1594 0 8 0C4.87187 0 2.175 1.79688 0.859375 4.41563L3.52187 6.48125C4.15312 4.59062 5.91875 3.18438 8 3.18438Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_20655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.6652ad0f002caf4c9073fdb2fdb80072.svg";
export { ForwardRef as ReactComponent };